const Patterns = {
  //email: /^((?!\.)[_.\w-]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/,
  
  text: /[\w ]{2,}/,
  
  phone: '^[0-9]{5,}$'
}


export default Patterns;